import { Skeleton } from '@mui/material';

type SkeletonRowProps = {
	columns: number;
	cellWidths?: (number | string)[];
};

export default function SkeletonRow({ columns, cellWidths }: SkeletonRowProps) {
	return (
		<tr>
			{Array.from({ length: columns }).map((_, i) => (
				<td key={i} className="px-6 py-4 whitespace-nowrap">
					<Skeleton
						variant="rounded"
						width={cellWidths?.[i] ?? (i === 0 ? 140 : 90)}
						height={20}
						animation="wave"
					/>
				</td>
			))}
		</tr>
	);
}
